<template>
  <div>
    <level-left>
      <a v-on:click="addEndpoint()" class="button add level-item add-endpoint">
        <i class="fas fa-plus"></i>
        {{ title }}
      </a>
      <p class="level-item">{{ endpoints.length }} Endpoints</p>
    </level-left>
    <removable-card
      v-for="endpoint in internalEndpoints"
      :key="endpoint.key"
      title="HTTP Endpoint"
      @cardDelete="removeEndpoint(endpoint.key)">
      <form-field icon="web" title="URL">
        <input v-model="endpoint.url"
          class="input endpoint-url"
          type="text"
          placeholder="URL">
      </form-field>
      <a v-on:click="addHeader(endpoint.key)" class="button add">
        <i class="fas fa-plus"></i>
        Add HTTP Header
      </a>
      <div
        v-for="(header) in endpoint.headers"
        :key="header.key"
        class="field is-horizontal header-row">
        <a
          v-on:click="removeHeader(endpoint.key, header.key)"
          class="button button-inverse full-height">
          <i class="fas fa-times"></i>
        </a>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input v-model="header.header"
                class="input endpoint-header"
                type="text"
                placeholder="Header">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input v-model="header.value"
                class="input endpoint-header"
                type="text"
                placeholder="Value">
            </div>
          </div>
        </div>
      </div>
    </removable-card>
  </div>
</template>

<script>
import _ from 'lodash';
import utils from '@/mixins/utils';
import RemovableCard from '@/components/RemovableCard.vue';
import LevelLeft from '@/components/LevelLeft.vue';
import FormField from '@/components/forms/FormField.vue';

export default {
  name: 'EndpointsForm',
  mixins: [utils],
  components: {
    RemovableCard,
    LevelLeft,
    FormField,
  },
  props: {
    endpoints: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  watch: {
    internalEndpoints: {
      deep: true,
      handler() {
        this.$emit('update:endpoints', _.map(this.internalEndpoints, e => ({
          url: e.url,
          headers: _.map(e.headers, h => _.omit(h, ['key'])),
        })));
      },
    },
  },
  beforeMount() {
    // Add a unique id to each endpoint
    this.internalEndpoints = _.map(this.endpoints, e => ({
      key: this.uuid(),
      url: e.url,
      headers: _.map(e.headers, h => ({
        key: this.uuid(),
        header: h.header,
        value: h.value,
      })),
    }));
  },
  methods: {
    removeEndpoint(key) {
      const index = _.findIndex(this.internalEndpoints, { key });
      this.internalEndpoints.splice(index, 1);
    },
    addEndpoint() {
      this.internalEndpoints.push({
        key: this.uuid(),
        url: '',
        headers: [],
      });
    },
    addHeader(key) {
      const index = _.findIndex(this.internalEndpoints, { key });
      this.internalEndpoints[index].headers.push({
        key: this.uuid(),
        header: '',
        value: '',
      });
    },
    removeHeader(endpointKey, headerkey) {
      const index = _.findIndex(this.internalEndpoints, { key: endpointKey });
      const headerIndex = _.findIndex(
        this.internalEndpoints[index].headers,
        { key: headerkey },
      );
      this.internalEndpoints[index].headers.splice(headerIndex, 1);
    },
  },
  data() {
    return {
      // Filled in by beforeMount
      internalEndpoints: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.header-row {
  margin-top: .25rem;
}
</style>
